<div class="p-5 bg-[#14192D]">

  <ng-container *ngIf="notification.type === 'welcome'">
    <div class="pt-5 flex-col items-center justify-start flex bg-[#14192D]">

      <div class="relative flex flex-col justify-center items-center w-full">
        <img
          class="rounded-[12px] mb-[14px] w-full"
          [src]="isExpanded ? 'assets/images/arkius/quick-guide.png' : 'assets/images/arkius/quick-guide-preview.png'"
          alt="Background"
        />
      </div>
        <div class="border-solid border-b-2 border-[#37A5D2] self-start w-full mb-[10px]">
      <h2 class=" text-white pt-[9px] pb-[8px]">Welcome, {{accountNickname}}!</h2>
      </div>
      <div
        class="flex flex-col text-white w-full justify-center items-center mt-[10px]"
      >
          <h2 class="self-start mb-[10px]">What is Share an Idea?</h2>
          <p class="text-base">
            A space to present an idea or innovative concept that has the potential to create value and drive improvement. The result of this stage is a Think Tank.
          </p>
          <div *ngIf="isExpanded" class="border-solid border-b-[2px] border-[#565761] w-full mt-[20px] h-[1px]"></div>
        <div
          *ngIf="isExpanded"
          class="mt-4 text-base flex flex-col items-start justify-start gap-[15px] w-full"
        >
          <div class="border-solid border-b-2 border-[#565761]">
            <h2 class="self-start mb-[10px]">What is Share a Problem?</h2>
            <p class="mb-[20px]">
              A space to present a societal issue, challenge, or unmet need that requires attention or a Solution. The result of this stage is a Think Tank.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <h2 class="self-start mb-[10px]">What is a Think Tank?</h2>
            <p class="mb-[20px]">
              A shared workspace where a group of people, with a shared goal, can develop and test ideas, for creating Solutions.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <h2 class="self-start mb-[10px]">What is a Solution?</h2>
            <p class="mb-[20px]">
              A Solution is an outline of the key ideas and requirements necessary to solve a problem. It details the actions that each supporter will take to give the Solution the political and economic power it needs to be realized in the marketplace.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <h2 class="self-start mb-[10px]">How do I create a Solution?</h2>
            <p class="mb-[20px]">
              Tap Create in the Navigation Bar, then tap on CREATE A THINK TANK. Once your Think Tank has an average Star Rating of 3.5+, 20+ Backers, and its content aligns with the
              <a routerLink="/account/help-center/community-guidelines" class="font-bold cursor-pointer text-white">Community Guidelines</a>,
              you will be able to convert your Think Tank to a Solution and distribute it to the Community.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <h2 class="self-start mb-[10px]">Why are Solutions powerful?</h2>
            <p class="mb-[20px]">
              Solutions harness the determination and commitment by millions of individuals to use their collective voting and buying power to change the world. Imagine a Solution where voters commit to only vote for those candidates who reject all outside funding and only accept limited campaign funds from their constituents. This would change politics forever since most elections are won by less than 10% of the vote.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <h2 class="self-start mb-[10px]">What are Inspire Points (IP)?</h2>
            <p class="mb-[10px]">
              Your Inspire Points (IP) reflect your overall impact, value and the community’s appreciation for your contributions. Your IP increases when you perform actions such as: expressing a bold, new idea, sharing a Solution on social media, inviting others who join, or engaging with other Members. The number to the right of your IP is your Recent Activity, which highlights your contributions over the past 30 days. As your IP climbs, you unlock exclusive badges, gaining the traction, visibility, and recognition you deserve.
            </p>
            <img
              class="mb-[10px]"
              src="assets/images/arkius/ip-box.png"
            />
          </div>
          <!-- <div class="border-solid border-b-2 border-[#565761]">
            <h2 class="self-start mb-[10px]">Comment or Reply</h2>
            <p class="mb-[30px]">
              You may Comment or Reply to a specific Think Tank or Solution. Comments and Replies help develop and question ideas related to the Think Tank or Solution. These discussions must stay on topic and be respectful. Ideas gain momentum as others upvote the ideas they like. Meaningful Comments and Replies are crucial to the development of the most powerful Solutions.
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="notification.type === 'appGuide'">
    <div class="pt-5 flex-col items-center justify-start flex bg-[#14192D]">
      
      <div class="relative flex flex-col justify-center items-center w-full">
        <img
          class="rounded-[12px] mb-[14px] w-full"
          [src]="isExpanded ? 'assets/images/arkius/lets-get-started.png' : 'assets/images/arkius/lets-get-started-preview.png'"
          alt="Background"
        />
      </div>

      <div
        class="flex flex-col text-white w-full justify-center items-center mt-[10px]"
      >
      <h2 class="self-start mb-[10px]">Let’s Get Started</h2>
      <p class="text-base">
        As a new Solutions Movement Member, you’re joining a global community of conscientious problem solvers who are eager to create and deliver change.
        <span *ngIf="isExpanded">
          <br><br>
          Tap <strong>Discover</strong> to search and follow Solutions and Think Tanks that spark your interests. <br><br>
          Share your ideas by creating or commenting on Solutions and Think Tanks.
        </span>
      </p>
      <div *ngIf="isExpanded" class="border-solid border-b-2 border-[#565761] w-full mt-[20px] h-[1px]"></div>
        
        <div
        *ngIf="isExpanded"
        class="mt-4 text-base flex flex-col items-start justify-start gap-[15px] w-full"
        >
          <div class="border-solid border-b-2 border-[#565761]">
            <div class="flex flex-row items-center justify-start gap-[10px]">
              <h2 class="self-start mb-[10px]">Inspire Points</h2>
              <img 
              class="mt-[-5px]"
              src="assets/images/arkius/icon-performance-index.png">
            </div>
            <p class="mb-[20px]">
              Inspire Points reflects the overall impact of your thoughts and ideas in driving the community or solutions forward. By sharing your ideas, you can gain likes and shares from others, increasing the visibility of your ideas. Higher Inspire Points signifies that your ideas resonate with the community, showcasing their value in advancing discussions or solutions. Within The Solutions Movement, the IP represents the community’s appreciation of your contributions. The number to the right of your IP indicates your Recent Activity for the last 30 days. The more value your ideas hold, the greater your influence is—and you're rewarded for the impact they create. Use your ideas to move the world forward—join The Solutions Movement today!
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <div class="flex flex-row items-center justify-start gap-[10px]">
              <h2 class="self-start mb-[10px]">Rating System</h2>
              <img 
              class="mt-[-5px]"
              src="assets/images/arkius/icon-star.png">
            </div>
            <p class="mb-[20px]">
              Rate Content between 1-10 stars (10 is best) to show support. Individual ratings are averaged into a single Rating for that content. The result is displayed next to the Star icon like this:  7.1 (72).  The average rating is 7.1 stars for the 72 Members that Rated that Content.  With these two metrics you can quickly see if others think the content is valuable and worth checking out. You can update your rating as often as you like, but any new rating on the same content will overwrite the previous one.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <div class="flex flex-row items-center justify-start gap-[10px]">
              <h2 class="self-start mb-[10px]">Follow</h2>
              <img 
              class="mt-[-5px]"
              src="assets/images/arkius/icon-heart.png">
            </div>
            <p class="mb-[20px]">
              Tap an Idea, Think Tank, Solution, or Member of interest to you, and then tap the Follow button. You will receive Solutions/Think Tanks/Comments/Replies in your “Home” feed on content/people you Follow.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <div class="flex flex-row items-center justify-start gap-[10px]">
              <h2 class="self-start mb-[10px]">Create</h2>
              <img 
              class="mt-[-5px]"
              src="assets/images/arkius/icon-ideas.png">
            </div>
            <p class="mb-[20px]">
              Tap <strong>Create</strong> to initiate a Solution or Think Tank. Use Think Tanks to brainstorm and develop Solutions with other Members. The output of a Think Tank is an actionable Solution for the Community.
            </p>
          </div>
          <div class="border-solid border-b-2 border-[#565761]">
            <div class="flex flex-row items-center justify-start gap-[10px]">
              <h2 class="self-start mb-[10px]">Manage your account</h2>
              <img 
              class="mt-[-5px]"
              src="assets/images/arkius/icon-profile.png">
            </div>
            <p class="mb-[20px]">
               Tap: <br>
              <strong>Profile</strong> to see content you created, to edit Market Sectors, and manage Profile.
              <br><br>
              <strong>Content</strong> to see all content: Think Tanks, Solutions, Comments, or Replies, that you create. <br><br>
              <strong>Badges</strong> to see all badges and awards earned. <br><br>

              <strong>Security & Settings</strong> to reset your password, set Notifications and Privacy settings. <br><br>
              <strong>Help Center</strong> to access helpful resources: FAQs, Quick Guide, Videos, etc. <br><br>
              <strong>Settings</strong> to connect with our team for support. <br><br>
              <strong>Log Out</strong> to logout of our App.
            </p>
          </div>
        </div>  
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="notification.type === 'communityGuidelines'">
    <div class="pt-5 flex-col items-center justify-start flex bg-[#14192D]">
      
      <div class="relative flex flex-col justify-center items-center w-full">
        <img
          class="rounded-[12px] mb-[14px] w-full"
          [src]="isExpanded ? 'assets/images/arkius/community-guidelines.png' : 'assets/images/arkius/community-guidelines-preview.png'"
          alt="Background"
        />
      </div>
        <div class="border-solid border-b-2 border-[#37A5D2] self-start w-full mb-[10px]">
      <h2 class=" text-white pt-[9px] pb-[8px]">Welcome, {{accountNickname}}!</h2>
      </div>

      <div
        class="flex flex-col text-white w-full justify-center items-center mt-[20px]"
      >
      <h2 class="self-start mb-[10px]">Here’s a snapshot of our Community Guidelines</h2>
      <p class="text-base">
        As a Member of The Solutions Movement, we invite you to advance its vision, respect fellow Members
        <span *ngIf="!isExpanded">...</span>
        <span *ngIf="isExpanded">
          , support freedom of expression, share appropriate content and act with integrity.
        </span>
      </p>
      <div *ngIf="isExpanded" class="border-solid border-b-2 border-[#565761] w-full mt-[20px] h-[1px]"></div>
        
        <div
        *ngIf="isExpanded"
        class="mt-4 text-base flex flex-col items-start justify-start gap-[15px] w-full"
        >
          <div
      class="mt-4 text-base flex flex-col items-start justify-start w-full">
        <h2 class="self-start mb-[10px]">Membership & Rights</h2>
        <p class="text-base">
          Membership, ownership, and voting rights are strictly reserved for verified humans, who retain complete control over their experience by customizing their own unique content filters and followings.
        </p>
        <div class="border-solid border-b-[2px] border-[#565761] w-full mt-[20px] h-[1px]"></div>
      </div>
      <div
        class="mt-4 text-base flex flex-col items-start justify-start gap-[15px] w-full"
      >
        <div class="border-solid border-b-2 border-[#565761]">
          <h2 class="self-start mb-[10px]">Equality & Integrity</h2>
          <p class="mb-[20px]">
            We protect true equality by ensuring every Member has an equal right to be heard and an equal vote, guaranteeing that platform power can never be bought, manipulated, or centralized.
          </p>
        </div>
        <div class="border-solid border-b-2 border-[#565761]">
          <h2 class="self-start mb-[10px]">Privacy, Ownership & Control of Data</h2>
          <p class="mb-[20px]">
            Every Member has complete ownership over their digital persona and data, as explained in our
            <a
              href="https://www.thesolutionsmovement.org/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
              class="font-bold cursor-pointer text-white"
              >Terms and Conditions</a
            >
            and
            <a
              href="https://www.thesolutionsmovement.org/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              class="font-bold cursor-pointer text-white"
              >Privacy Policy</a
            >.
          </p>
        </div>
        <div class="border-solid border-b-2 border-[#565761]">
          <h2 class="self-start mb-[10px]">Transparency</h2>
          <p class="mb-[20px]">
            Every Member has equal access to unfiltered information and clear insight into how data and algorithms shape the Community experience—without censorship, manipulation, or centralized control.
          </p>
        </div>
        <div class="border-solid border-b-2 border-[#565761] w-full">
          <h2 class="self-start mb-[10px]">Respect and Civility</h2>
          <p class="mb-[30px]">
            To protect freedom of expression and treat every Member with respect, we prohibit harmful content, harassment, and coordinated bullying to keep our Community safe, fair, and inclusive.
          </p>
        </div>
        <!-- <div class="border-solid border-b-2 border-[#565761]">
          <h2 class="self-start mb-[10px]">Respect, Civility, & Conflict Resolution</h2>
          <p class="mb-[20px]">
            Treat others as you wish to be treated. Freedom of expression is celebrated, but harmful content is strictly prohibited.
          </p>
        </div> -->
        <div class="border-solid border-b-2 border-[#565761]">
          <h2 class="self-start mb-[10px]">Let’s build a thriving, respectful, and impactful Community together!</h2>
          <p class="mb-[30px]">
            Review our full Community Guidelines.
          </p>

          <ark-button
      class="button-icon w-full mb-[30px]"
      type="light"
      leftIcon="system-globe"
      (click)="goToCommunityGuidelines()"
      >COMMUNITY GUIDELINES</ark-button>

        </div>

      </div>
        </div>  
      </div>
    </div>
  </ng-container>

  <!-- Buttons Container -->
  <div class="flex flex-row justify-center gap-4 mt-4 w-full">
    <ark-button
      class="bg-[#14192D] w-full"
      type="transparent"
      (click)="dismiss.emit(notification.systemNotificationId)"
      >DISMISS</ark-button
    >
    <ark-button
      class="w-full"
      type="light"
      (click)="handleReadMore(notification.systemNotificationId)"
    >
      {{ !isExpanded ? 'Read More ' : 'Read Less' }}
    </ark-button>
  </div>
</div>
